import { Component, EventEmitter, HostListener, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { merge, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { AclTipo } from 'src/app/model/AclTipo.enum';
import { StatiEvento } from 'src/app/model/StatiEvento.enum';
import { StatiSegnalazione } from 'src/app/model/StatiSegnalazione.enum';
import { DialogService } from 'src/app/services/dialog.service';
import { EntiService } from 'src/app/services/enti.service';
import { EventiService } from 'src/app/services/eventi.service';
import { SegnalazioneEditabileService } from 'src/app/services/segnalazione-editabile.service';
import { SegnalazioniDataSource } from 'src/app/services/segnalazioni.datasource';
import { SegnalazioniService } from 'src/app/services/segnalazioni.service';
import { Toolbar, ToolbarEvent } from 'src/app/shared/components/toolbar/toolbar';
import { StatiIntervento } from '../elenco-interventi/elenco-interventi.component';
import { InviaSegnalazioniComponent } from '../invia-segnalazioni/invia-segnalazioni.component';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-lista-segnalazioni-evento',
  templateUrl: './lista-segnalazioni-evento.component.html',
  styleUrls: ['./lista-segnalazioni-evento.component.css']
})
export class ListaSegnalazioniEventoComponent implements OnInit, OnDestroy {

  idEvento: string;
  arrowFlag: boolean = false;
  risultatiPerPagina: number = 10;
  public form: FormGroup;
  dataSource: SegnalazioniDataSource;
  acl: string = '';
  confirmed: string;
  select: boolean = false;
  selezionaTutti: string = "";
  controlList: ModelEventiCalamitosi.SegnalazioneDto[] = [];
  abilitazioniPerListaSegnalazioni: { canDgpeUpdate: boolean, canDpcplUpdate: boolean, canUpdate: boolean }
  listaEnti: ModelEventiCalamitosi.EnteDto[] = [];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Output()
  public onToolbarEvent: EventEmitter<ToolbarEvent> = new EventEmitter();

  public searchFilters: ModelEventiCalamitosi.SegnalazioniSearchableDto = {
    idEvento: this.route.snapshot.params.id,
    codiceSegnalazione: null,
    stato: null,
    idEnte: null,
    descrizioneSegnalazione: null,
    tipoRichiesta: null,
    identificativoInvio: null,
    flRettificata:null
  };

  displayedColumns: string[] = ['codiceSegnalazione', 'descrizioneCodiceEnte', 'tipoRichiesta', 'descrizioneSegnalazione', 'stato', 'rettificata', 'idInvio', 'actions'];
  denominazione: string;
  abilitatoCompilazione: boolean;
  abilitatoCorrezione: boolean = false;
  segnalazioniInviabili: boolean = false;
  openToggle: number;
  statoEvento: string = '';
  sottoscrizione: Subscription;
  operazioni: ModelEventiCalamitosi.OperazioniSegnalazioni[];
  showButtonEsegui: boolean = false;
  operazioneMassiva: string = "";
  toolbar: Toolbar;

  constructor(
    private dialogSvc: DialogService,
    public dialog: MatDialog,
    private segnalazioniDialogSvc: DialogService,
    private segnalazioneEditabileService: SegnalazioneEditabileService,
    private route: ActivatedRoute, private router: Router,
    private eventoSvc: EventiService,
    private entiService: EntiService,
    private segnalazioniSvc: SegnalazioniService,
    private alertsCenterService: AlertsCenterService,
    private http: HttpClient) {

    this.idEvento = this.route.snapshot.params.id;
    this.buildForm();
    this.acl = sessionStorage.getItem("acl");

    this.eventoSvc.getEvento(+this.idEvento).toPromise().then(evento => {
      this.denominazione = evento.denominazione;
      this.statoEvento = evento.stato;
    })

    // controlla se è abilitato alla raccolta di almeno 1 template, per inserire button di inserisci/invia segnalazione
    this.entiService.getEnteAbilitatoAlmenoAdUnTemplatePerEvento(+this.idEvento).subscribe(abilitato => {
      this.abilitatoCompilazione = abilitato.abilitatoRaccoltaAlmenoUno;
      this.abilitatoCorrezione = abilitato.abilitatoCorrezioneAlmenoUno;
    });

    this.operazioni = this.segnalazioniSvc.getOperazioni();

  }

  ngOnInit(): void {
    if (this.acl == "dpcpl" || this.acl == "dgpe") {
      this.entiService.getEntiProfilatiList().subscribe(res => {
        this.listaEnti = res;
      })
    }
    this.sottoscrizione = this.segnalazioneEditabileService.modificatoStatoObservable.subscribe(nuovoStato => {
      this.dataSource.loadListaSegnalazioni('', this.controlList, this.searchFilters, 'codiceSegnalazione, DESC', this.paginator.pageIndex, this.paginator.pageSize, 0);
    });
    this.form.controls.operazione.valueChanges.subscribe(res => {
      this.selezionaTutti = "";
      this.operazioneMassiva = res;
      if (res != undefined && res != null && res != '') {
        let stato = '';
        stato = this.computaStatoDaOperazione(res);
        if (!this.displayedColumns.includes('operazione')) {
          this.displayedColumns.push('operazione')
        }
        this.searchFilters = {
          idEvento: this.route.snapshot.params.id,
          codiceSegnalazione: this.form.controls['codiceSegnalazione'].value !== "" ? this.form.controls['codiceSegnalazione'].value : null,
          stato: stato,
          idEnte: this.form.controls['idEnte'].value !== "" ? this.form.controls['idEnte'].value : null,
          descrizioneSegnalazione: this.form.controls['descrizioneSegnalazione'].value !== "" ? this.form.controls['descrizioneSegnalazione'].value : null,
          tipoRichiesta: this.form.controls['tipologia'].value !== "" ? this.form.controls['tipologia'].value : null,
          identificativoInvio: this.form.controls['identificativoInvio'].value !== "" ? this.form.controls['identificativoInvio'].value : null,
          flRettificata: this.form.controls['flRettificata'].value !== "" ? this.form.controls['flRettificata'].value : null
        };
        this.dataSource.loadListaSegnalazioni('', this.controlList, this.searchFilters, 'codiceSegnalazione,'+this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize, 0);
      } else {
        if (this.displayedColumns.includes('operazione')) {
          this.displayedColumns.pop();
          this.onReset();
        }
      }
    })
    this.dataSource = new SegnalazioniDataSource(this.segnalazioniSvc);
    this.dataSource.errors$.subscribe(res => {
      if (res) this.alertsCenterService.showAlert({
        message: `Errore lettura dati`,
        type: 'danger',
        autoClosable: false
      });
    })
    this.showButtonEseguiFunction();
  }

  showButtonEseguiFunction() {
    this.dataSource.countSubject.subscribe(res => {
      if (res == 0) {
        this.showButtonEsegui = false;
      } else if (res > 0 && this.select == true) {
        let operazione = this.form.controls['operazione'].value
        if (operazione == "RICEVI_SEGNALAZIONI" || operazione == "SEGNALAZIONI_NON_RICEVUTE") {
          let idEnte = this.form.controls['idEnte'].value !== "" ? this.form.controls['idEnte'].value : null;
          let identificativoInvio = this.form.controls['identificativoInvio'].value !== "" ? this.form.controls['identificativoInvio'].value : null;

          if (idEnte != undefined && idEnte != null && idEnte != "" && identificativoInvio != undefined && identificativoInvio != null && identificativoInvio > 0) {
              this.showButtonEsegui = true;
          } else {
            this.showButtonEsegui = false;
          }
        } else {
          this.showButtonEsegui = true;
        }
      } else {
        this.showButtonEsegui = false;
      }
    });
  }

  private computaStatoDaOperazione(res: any) {
    let stato = null;
    if (res == "RICEVI_SEGNALAZIONI" || res == "SEGNALAZIONI_NON_RICEVUTE") {
      if (this.acl == "dpcpl") {
        stato = StatiSegnalazione.INVIATA;
      } else if (this.acl == "dgpe") {
        stato = StatiSegnalazione.INVIATA_PE;
      }
    } else if (res == "CONFERMA_SEGNALAZIONI" || res == "RIFIUTA_SEGNALAZIONI") {
      if (this.acl == "dpcpl") {
        stato = StatiSegnalazione.RICEVUTA;
      } else if (this.acl == "dgpe") {
        stato = StatiSegnalazione.RICEVUTA_PE;
      }
    }
    return stato;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.sort.direction = "desc";
      this.sort.active = "codiceSegnalazione";
      this.dataSource.loadListaSegnalazioni('', this.controlList, this.searchFilters, this.sort.active+","+this.sort.direction, 0, this.risultatiPerPagina, 0);

      this.form.valueChanges.subscribe(() => this.paginator.pageIndex = 0);
      // reset the paginator after sorting
      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

      merge(this.sort.sortChange, this.paginator.page)
        .pipe(
          tap(() => {
            this.ricercaListaSegnalazioni();
          }))
        .subscribe();

      this.dataSource.counter$
        .pipe(
          tap((count) => {
            this.paginator.length = count;
          })
        )
        .subscribe();

    });

  }

  public checkStato(stato: string): boolean {
    return stato == StatiEvento.ATTESA_EMERGENZA || stato == StatiEvento.POST_EMERGENZA ? false : true;
  }

  showSelect() {
    this.select = !this.select;
    if (this.select == false) {
      this.form.controls['operazione'].reset();
      this.showButtonEsegui = false;
    }
  }

  setSelezionaTutti(completed: boolean) {
    this.controlList = [];
    if (completed === true) {
      this.selezionaTutti = "S";
    } else {
      this.selezionaTutti = "N"
    }
    this.dataSource.loadListaSegnalazioni('', this.controlList, this.searchFilters, 'codiceSegnalazione,DESC', this.paginator.pageIndex, this.paginator.pageSize, 0, this.selezionaTutti);
  }

  setConfigurationSelezionato(element) {
    element.selezionato = element.selezionato === 'S' ? 'N' : 'S';
    element.selezionatoFE = true;
    /**
     * fix
     */
    let present = false;
    this.controlList.forEach((ele, index) => {
      if (ele.codiceSegnalazione === element.codiceSegnalazione) {
        this.controlList.splice(index, 1);
        present = true;
      }
    });
    if (!present) this.controlList.push(element);
  }


  public valorizzaSearchFilter() {
    return {
      idEvento: this.route.snapshot.params.id,
      codiceSegnalazione: this.form.controls['codiceSegnalazione'].value !== "" ? this.form.controls['codiceSegnalazione'].value : null,
      stato: this.form.controls['stato'].value !== "" ? this.form.controls['stato'].value : null,
      idEnte: this.form.controls['idEnte'].value !== "" ? this.form.controls['idEnte'].value : null,
      descrizioneSegnalazione: this.form.controls['descrizioneSegnalazione'].value !== "" ? this.form.controls['descrizioneSegnalazione'].value : null,
      tipoRichiesta: this.form.controls['tipologia'].value !== "" ? this.form.controls['tipologia'].value : null,
      identificativoInvio: this.form.controls['identificativoInvio'].value !== "" ? this.form.controls['identificativoInvio'].value : null,
      statoPerOperazione: this.computaStatoDaOperazione(this.form.controls['operazione'].value),
      flRettificata: this.form.controls['flRettificata'].value !== "" ? this.form.controls['flRettificata'].value : null
    }
  }

  public ricercaListaSegnalazioni(resetPage?: boolean): void {
    this.searchFilters = this.valorizzaSearchFilter();
    //console.log(this.sort.active+","+this.sort.direction);
    this.dataSource.loadListaSegnalazioni('', this.controlList, this.searchFilters, this.sort.active+","+this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize, 0, this.selezionaTutti);
  }

  private buildForm(): void {
    let group = {
      codiceSegnalazione: new FormControl(null, null),
      stato: new FormControl(null, null),
      idEnte: new FormControl(null, null),
      descrizioneSegnalazione: new FormControl(null, null),
      tipologia: new FormControl(null, null),
      operazione: new FormControl(null, null),
      identificativoInvio: new FormControl(null, null),
      flRettificata: new FormControl(null, null)
    }
    this.form = new FormGroup(group);
  }

  openToolbar(codiceSegnalazione: number, statoSegnalazione: String, rettificata: string) {


    this.segnalazioniSvc.checkIfEditabile(codiceSegnalazione).subscribe(res => {
      this.abilitazioniPerListaSegnalazioni = res;
      this.toolbar = {} as Toolbar;
      this.generateToolBar(statoSegnalazione, rettificata, codiceSegnalazione);
      this.openToggle = codiceSegnalazione;
    })

  }

  public generateToolBar(statoSegnalazione: String, rettificata: string, codiceSegnalazione:number) {

    let toolbar: Toolbar = {
      toolbarCss: 'toolbar-vertical',
      actions: [{
        btnTitle: 'Dettaglio',
        btnIconClass: 'article',
        btnActionEvent: 'detail',
        btnCssClass: 'btn btn-secondary'
      }]
    }

    if (this.acl == AclTipo.EELL) {

      // Vede se come ente ho accesso alla raccolta o alla correzione o entrambe per una specifica segnalazione
      this.entiService.checkPermessiEELLperSegnalazione(codiceSegnalazione).subscribe( res => {

        // Controlla le azioni disponibili per la segnalazione in base all'ente ed all'abilitazione del template
        let abilitazioniEELLSegnalazione : ModelEventiCalamitosi.AbilitazioniEnteSuSegnalazione = res;
        let statoIntervento = abilitazioniEELLSegnalazione.statoInterventoAssociato;

        if (statoSegnalazione === StatiSegnalazione.RICHIESTA_INTEGRAZIONE) {
          toolbar.actions.push({
            btnTitle: 'Correggi segnalazione',
            btnIconClass: 'edit_document',
            btnActionEvent: 'correggi-richiesta-integrazione',
            btnCssClass: 'btn btn-secondary'
          });
        }

        switch (this.statoEvento) {
          case StatiEvento.RACCOLTA_DATI:

          // Caso in cui come EELL posso riaprire la correzione di una mia segnalazione
            if (this.segnalazioneEditabileService.isRiapribile(this.acl, statoSegnalazione.toString(),this.statoEvento,abilitazioniEELLSegnalazione.abilitatoCorrezione )) {
              toolbar.actions.push({
                btnTitle: 'Correggi segnalazione',
                btnIconClass: 'exit_to_app',
                btnActionEvent: 'riapertura-segn-rifiutata',
                btnCssClass: 'btn btn-secondary'
              });
            }
            else if ((statoSegnalazione == StatiSegnalazione.IN_BOZZA || statoSegnalazione == StatiSegnalazione.COMPLETATA)) {
              if (rettificata === 'S' && abilitazioniEELLSegnalazione.abilitatoCorrezione) {
                toolbar.actions.push({
                  btnTitle: 'Correggi',
                  btnIconClass: 'create',
                  btnActionEvent: 'edit',
                  btnCssClass: 'btn btn-secondary'
                });
              } else if (rettificata === 'N' && abilitazioniEELLSegnalazione.abilitatoRaccolta) {
                toolbar.actions.push({
                  btnTitle: 'Modifica',
                  btnIconClass: 'create',
                  btnActionEvent: 'edit',
                  btnCssClass: 'btn btn-secondary'
                }, {
                  btnTitle: 'Elimina',
                  btnIconClass: 'delete',
                  btnActionEvent: 'delete',
                  btnCssClass: 'btn btn-secondary'
                });
              }
            }
            break;
            // In RACC_DATI_PE posso aggiungere nuove segnalazioni (bozza_pe in poi) se aperta raccolta_pe per ente
            // posso correggere le rettificate se abilitata la correzione
            // non posso toccare le segnalazioni nella fase di pre-emergenza
          case StatiEvento.RACCOLTA_DATI_PE:

            if (this.segnalazioneEditabileService.isRiapribile(this.acl, statoSegnalazione.toString(),this.statoEvento,abilitazioniEELLSegnalazione.abilitatoCorrezione )) {
              toolbar.actions.push({
                btnTitle: 'Correggi segnalazione',
                btnIconClass: 'exit_to_app',
                btnActionEvent: 'riapertura-segn-rifiutata',
                btnCssClass: 'btn btn-secondary'
              });
            } else if ((statoSegnalazione == StatiSegnalazione.IN_BOZZA_PE ||
              statoSegnalazione == StatiSegnalazione.COMPLETATA_PE ||
              statoSegnalazione == StatiSegnalazione.APERTA_PE)) {

                // controllo dell'intervento associato (se esiste)
                if (statoIntervento !== '') {

                  if (!(statoIntervento === StatiIntervento.IN_ATTESA_DI_FINANZIAMENTO || statoIntervento === StatiIntervento.RESPINTO ||
                    statoIntervento === StatiIntervento.PREVENTIVAMENTE_RESPINTO || statoIntervento === StatiIntervento.IN_PROPOSTA_DI_FINANZIAMENTO ||
                    statoIntervento === StatiIntervento.ESPUNTO)) {

                      if (rettificata === 'S' && abilitazioniEELLSegnalazione.abilitatoCorrezione) {
                        toolbar.actions.push({
                          btnTitle: 'Correggi',
                          btnIconClass: 'create',
                          btnActionEvent: 'edit',
                          btnCssClass: 'btn btn-secondary'
                        });
                      } else if (rettificata === 'N' && abilitazioniEELLSegnalazione.abilitatoRaccolta) {
                        toolbar.actions.push({
                          btnTitle: 'Modifica',
                          btnIconClass: 'create',
                          btnActionEvent: 'edit',
                          btnCssClass: 'btn btn-secondary'
                        });
                      }
                    }
                }
                // Se non ha interventi associati posso eliminarle perchè sono nuove
                else {
                  if (rettificata === 'S' && abilitazioniEELLSegnalazione.abilitatoCorrezione) {
                    toolbar.actions.push({
                      btnTitle: 'Correggi',
                      btnIconClass: 'create',
                      btnActionEvent: 'edit',
                      btnCssClass: 'btn btn-secondary'
                    });
                  } else if (rettificata === 'N' && abilitazioniEELLSegnalazione.abilitatoRaccolta) {
                    toolbar.actions.push({
                      btnTitle: 'Modifica',
                      btnIconClass: 'create',
                      btnActionEvent: 'edit',
                      btnCssClass: 'btn btn-secondary'
                    }, {
                      btnTitle: 'Elimina',
                      btnIconClass: 'delete',
                      btnActionEvent: 'delete',
                      btnCssClass: 'btn btn-secondary'
                    });
                  }
                }
            }
            break;
          default:
            break;
        }
        this.toolbar = toolbar;
      },
      err => {
        this.alertsCenterService.showAlert({
          message: `Errore durante la creazione della toolbar`,
          type: 'danger',
          autoClosable: false
        });
        this.toolbar = toolbar;
      });

    } else if (this.acl == AclTipo.DPCPL || this.acl == AclTipo.DGPE) {

      if (this.segnalazioneEditabileService.isNonRicevuta(this.acl, statoSegnalazione.toString(), this.abilitazioniPerListaSegnalazioni)) {
        toolbar.actions.push({
          btnTitle: 'Non ricevere',
          btnIconClass: 'delete_forever',
          btnActionEvent: 'nonricezione',
          btnCssClass: 'btn btn-secondary'
        });
      }
      if (this.segnalazioneEditabileService.isRifiutabile(this.acl, statoSegnalazione.toString(), this.abilitazioniPerListaSegnalazioni)) {
        toolbar.actions.push({
          btnTitle: 'Rifiuta',
          btnIconClass: 'clear',
          btnActionEvent: 'rifiuta',
          btnCssClass: 'btn btn-secondary'
        });
      }
      if (this.segnalazioneEditabileService.isRicevibile(this.acl, statoSegnalazione.toString(), this.abilitazioniPerListaSegnalazioni)) {
        toolbar.actions.push({
          btnTitle: 'Ricevi',
          btnIconClass: 'move_to_inbox',
          btnActionEvent: 'ricevi',
          btnCssClass: 'btn btn-secondary'
        });
      }
      if (this.segnalazioneEditabileService.isConfermabile(this.acl, statoSegnalazione.toString(), this.abilitazioniPerListaSegnalazioni)) {
        toolbar.actions.push({
          btnTitle: 'Conferma',
          btnIconClass: 'done',
          btnActionEvent: 'conferma',
          btnCssClass: 'btn btn-secondary'
        });
      }
      this.toolbar = toolbar;
    }

    this.toolbar = toolbar;
  }

  public handleToolbarEvent(event: ToolbarEvent): void {
    if (event.event === 'edit') {
      this.router.navigate([this.router.url + '/compilazione-segnalazione/' + event.data.codiceSegnalazione]);
    } else if (event.event === 'detail') {
      this.router.navigate([this.router.url + '/dettaglio-segnalazione/' + event.data.codiceSegnalazione]);
    } else if (event.event === 'delete') {
      this.openRemoveSegnalazioneDialog(event.data.codiceSegnalazione);
    } else if (event.event === 'correggi-richiesta-integrazione') {
      this.openConfermaCorrezioneModale(event.data.codiceSegnalazione);
    } else if (event.event === 'nonricezione') {
      this.segnalazioneEditabileService.changeStatoSegnalazione(this.acl, 'nonricezione', event.data.codiceSegnalazione, event.data.stato);
    } else if (event.event === 'rifiuta') {
      this.segnalazioneEditabileService.changeStatoSegnalazione(this.acl, 'rifiutare', event.data.codiceSegnalazione, event.data.stato);
    } else if (event.event === 'ricevi') {
      this.segnalazioneEditabileService.changeStatoSegnalazione(this.acl, 'validare', event.data.codiceSegnalazione, event.data.stato);
    } else if (event.event === 'conferma') {
      this.segnalazioneEditabileService.changeStatoSegnalazione(this.acl, 'confermare', event.data.codiceSegnalazione, event.data.stato);
    } else if (event.event === 'riapertura-segn-rifiutata') {
      this.segnalazioneEditabileService.changeStatoSegnalazione(this.acl, 'correzione', event.data.codiceSegnalazione, event.data.stato, event.data.statoIntervento);
    }
    this.openToggle = null;
  }

  // Metodo per aprire la modale di conferma
  private openConfermaCorrezioneModale(codiceSegnalazione: number): void {
    let title = 'Correzione segnalazione';
    let message = 'La segnalazione verrà riportata in bozza. L\'operazione permetterà di correggere la segnalazione. Vuoi procedere con l\'operazione?';

    this.dialogSvc.openDialog(title, message).subscribe(
      confirmed => {
        if (confirmed) {
          this.setStatoSegnalazioneInBozza(codiceSegnalazione);
        }
      }
    );
  }

  // Metodo per inviare la richiesta POST e cambiare lo stato
  private setStatoSegnalazioneInBozza(codiceSegnalazione: number): void {
    const url = '/eventicalamitosi/api/segnalazione/set-stato-segnalazione';
    const body = {
      idDatiRaccolti: codiceSegnalazione,
      stato: StatiSegnalazione.IN_BOZZA
    };

    this.http.post(url, body).subscribe({
      next: (response) => {
        this.alertsCenterService.showAlert({
          message: 'Segnalazione riportata in bozza con successo.',
          type: 'success',
          autoClosable: true
        });
        this.ricercaListaSegnalazioni();
      },
      error: (error) => {
        console.error('Errore durante l\'aggiornamento dello stato:', error);
        this.alertsCenterService.showAlert({
          message: `Errore: ${error.error?.esitoServizio?.descrizioneEsito || 'Impossibile aggiornare lo stato.'}`,
          type: 'danger',
          autoClosable: false
        });
      }
    });
  }

  onNavigate() {
    this.router.navigate(['gestione-segnalazioni']);
  }

  inserisciSegnalazione() {
    this.router.navigate([this.router.url + '/compilazione-segnalazione']);
  }

  openRemoveSegnalazioneDialog(codiceSegnalazione: number) {
    let title = 'Eliminazione segnalazione';
    let message = '<b>Eliminando la segnalazione saranno cancellati anche i dati storici!</b> <br><br> Vuoi davvero eliminare questa segnalazione?'
    this.segnalazioniDialogSvc.openDialog(title, message).subscribe(
      result => {
        this.confirmed = `${result}`;
        if (this.confirmed == "true") {
          this.segnalazioniSvc.deleteSegnalazione(codiceSegnalazione).subscribe(data => {
            this.alertsCenterService.showAlert({
              message: `Cancellazione effettuata con successo`,
              type: 'success',
              autoClosable: false
            });
            this.ricercaListaSegnalazioni();
          }, error => {
            this.alertsCenterService.showAlert({
              message: `Errore durante la cancellazione`,
              type: 'danger',
              autoClosable: false
            });
          }
          );
        }
      }
    );
  }

  openDialogOperazioneSegnalazioneDialog() {

    let title = ""
    let message = ""
    let messageStatus = "";
    if (this.operazioneMassiva == "RICEVI_SEGNALAZIONI") {
      title = "Ricevi segnalazioni"
      message = "Le segnalazioni selezionate verranno contrassegnate tutte come ricevute"
      messageStatus = "Segnalazioni ricevute con successo";
    } else if (this.operazioneMassiva == "SEGNALAZIONI_NON_RICEVUTE") {
      title = "Segnalazioni non ricevute"
      message = "Le segnalazioni selezionate verranno contrassegnate tutte come non ricevute"
      messageStatus = "Segnalazioni contrassegnate come non ricevute con successo";
    } else if (this.operazioneMassiva == "CONFERMA_SEGNALAZIONI") {
      title = "Conferma segnalazioni"
      message = "Le segnalazioni selezionate verranno contrassegnate tutte come confermate"
      messageStatus = "Segnalazioni confermate con successo";
    } else if (this.operazioneMassiva == "RIFIUTA_SEGNALAZIONI") {
      title = "Rifiutare segnalazioni"
      message = "Aggiungere una motivazione e confermare per procedere con il rifiuto delle segnalazioni"
      //messageStatus NON va settato qui perché flag non è ancora disponibile
    }

    let segnalazioniUpdateMassivaDto: ModelEventiCalamitosi.SegnalazioniUpdateMassivaDTO = {
      selezionaTutti: this.selezionaTutti,
      operazione: this.operazioneMassiva,
      segnalazioni: [],
      messaggio: '',
      filterSegnalazione: this.valorizzaSearchFilter(),
      flagRichiestaIntegrazione: false
    }

    if (this.controlList.length > 0 || (this.selezionaTutti != null && this.selezionaTutti != "" && this.selezionaTutti != "N")) {
      let isRifiutoMassivo = false;
      let inputTitle = title;
      let isOperazioneMassiva = true;
      let flagRichiestaIntegrazioneDialog = false;
      if (this.operazioneMassiva == "RIFIUTA_SEGNALAZIONI") {
        inputTitle = 'Motivazione rifiuto'
        isRifiutoMassivo = true;
        isOperazioneMassiva = false;
      }
      this.dialogSvc.openOperazioneMassivaDialog(title, message, isOperazioneMassiva, isRifiutoMassivo, inputTitle).subscribe(res => {
          if (res !== '') {
            const parsed = JSON.parse(res);
            segnalazioniUpdateMassivaDto.segnalazioni = this.controlList;
            segnalazioniUpdateMassivaDto.messaggio = parsed.motivazione;

            const flagRichiestaIntegrazione = parsed.inAttesaChiarimenti;
            segnalazioniUpdateMassivaDto.flagRichiestaIntegrazione = flagRichiestaIntegrazione;
            // Imposta il messaggio dopo aver ottenuto il flag
            if (this.operazioneMassiva === 'RIFIUTA_SEGNALAZIONI') {
              if (flagRichiestaIntegrazione) {
                messageStatus = 'Segnalazioni in richiesta di integrazione';
              } else {
                messageStatus = 'Segnalazioni rifiutate con successo';
              }
            }

          this.segnalazioniSvc.changeStatusSegnalazioniMassivo(segnalazioniUpdateMassivaDto).subscribe(
            res => {
              if(messageStatus){
                this.alertsCenterService.showAlert({
                  message: messageStatus + ", numero di segnalazioni: " + res.body,
                  type: 'success',
                  autoClosable: false
                });
                this.onReset();
              }
            },
            err => {
              this.alertsCenterService.showAlert({
                message: err.error.esitoServizio.descrizioneEsito,
                type: 'danger',
                autoClosable: false
              });
            });
        }
      });
    } else {
      this.alertsCenterService.showAlert({
        message: `Selezionare almeno una segnalazione`,
        type: 'danger',
        autoClosable: false
      });
    }
  }

  openInviaSegnalazioneDialog() {
    //inserire qui la configurazione della material dialog MatDialogConfig per dati e css
    this.segnalazioniSvc.getNumeroSegnalazioniInviabili(+this.idEvento).subscribe(num => {
      if (num > 0) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
          idEvento: this.route.snapshot.params.id,
        }
        dialogConfig.maxWidth = '120vw';
        dialogConfig.width = '600px';
        const dialogRef = this.dialog.open(InviaSegnalazioniComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(result => {
          this.ricercaListaSegnalazioni();
        });
      } else {
        this.alertsCenterService.showAlert({
          message: "Nessuna segnalazione è nello stato opportuno per l'invio o periodo di raccolta/correzione dati scaduto per tipologia segnalazione",
          type: 'danger',
          autoClosable: false,
        });
      }
    }, err => {
      this.alertsCenterService.showAlert({
        message: 'Errore in recupero numero di segnalazioni inviabili...',
        type: 'danger',
        autoClosable: false,
      });
    });

  }

  onReset() {
    this.searchFilters = {
      idEvento: this.route.snapshot.params.id,
      codiceSegnalazione: null,
      stato: null,
      idEnte: null,
      descrizioneSegnalazione: null,
      tipoRichiesta: null,
      identificativoInvio: null,
      flRettificata:null
    }
    this.controlList = [];
    this.selezionaTutti = "";
    this.select = false;
    this.showButtonEsegui = false;
    this.form.reset();
    this.sort.direction = "desc";
    this.dataSource.loadListaSegnalazioni('', this.controlList, this.searchFilters, 'codiceSegnalazione,'+this.sort.direction, 0, this.risultatiPerPagina, 0, this.selezionaTutti);
  }

  onExportCsv() {
    this.dialogSvc.openDialogGestioneCampiExport(+this.idEvento).subscribe(res => {

      // undefined/null se la chiudo cliccando fuori, false se premo annulla
      if (res !== null && res !== undefined && res !== false) {

        this.searchFilters = this.valorizzaSearchFilter();
        this.segnalazioniSvc.getNumeroSegnalazioniEsportabili(this.searchFilters).subscribe(num => {
          if (num > 0) {
            let reportObject: ModelEventiCalamitosi.ExportCsvWrapperDTO = {
              filterSegnalazione: this.searchFilters,
              listaCampiVisualizzabili: res
            } // setto la lista dei campi che voglio visualizzare nell'excell

            this.segnalazioniSvc.downloadReportAggregatoSegnalazioni(reportObject).subscribe(
              response => {
                let dataType = response.type.toString();
                let binaryData = [];
                binaryData.push(response.body);
                let contentDisposition = response.headers.get('content-disposition')
                let filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
                filename = filename.replace(/"/g, '');
                let downloadLink = document.createElement('a');
                downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
                downloadLink.setAttribute('download', filename);
                document.body.appendChild(downloadLink);
                downloadLink.click();
              }, err => {
                this.alertsCenterService.showAlert({
                  message: 'Errore in fase di download del file...',
                  type: 'danger',
                  autoClosable: false,
                });
              });
          } else {
            this.alertsCenterService.showAlert({
              message: 'Il filtro attualmente selezionato non contiene alcuna segnalazione',
              type: 'danger',
              autoClosable: false,
            });
          }
        }, err => {
          this.alertsCenterService.showAlert({
            message: 'Errore in recupero numero segnalazioni filtrate per export',
            type: 'danger',
            autoClosable: false,
          });
        });
      }
    });
  }

  //rimane in ascolto: se il click non è fatto sull'icona chiude il menù
  @HostListener('document:click', ['$event'])
  documentClick(event) {
    if (event.srcElement.innerText !== 'more_horiz') this.openToggle = 0;
  }

  ngOnDestroy() {
    this.sottoscrizione.unsubscribe();
  }
}
